export function FinanceIcon({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18 6C11.3726 6 6 11.3726 6 18C6 24.6274 11.3726 30 18 30C24.6274 30 30 24.6274 30 18C30 11.3726 24.6274 6 18 6Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18 11V13M18 23V25M21 14C21 12.8954 20.1046 12 19 12H17C15.8954 12 15 12.8954 15 14C15 15.1046 15.8954 16 17 16H19C20.1046 16 21 16.8954 21 18C21 19.1046 20.1046 20 19 20H17C15.8954 20 15 19.1046 15 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
